<template>
    <div class="wbk-projects-container" v-if="projectsDataLoaded">
        <div class="wbk-projects-column">
            <wbk-categories></wbk-categories>
            <wbk-map @selectRegion="updateSelectedRegions"></wbk-map>
        </div>
        <div class="wbk-projects-column">
            <wbk-projects ref="projectsComponent"></wbk-projects>
        </div>
    </div>
</template>

<script>
    import Categories from './components/Categories.vue'
    import Map from './components/Map.vue'
    import Projects from './components/Projects.vue'

    export default {
        name: 'WBKProjectsTool',
        components: {
            'wbk-categories': Categories,
            'wbk-map': Map,
            'wbk-projects': Projects
        },
        data() {
            return {
                projectsDataLoaded: false
            }
        },
        methods: {
            updateSelectedRegions( value ) {
                if ( !value ) return

                this.$refs.projectsComponent.updateSelectedRegions( value )
            }
        },
        async mounted() {
            await this.$store.dispatch( 'fetchProjectsData' ).then( () => this.projectsDataLoaded = true )
        }
    }
</script>

<style lang="scss">
@import "vue-multiselect/dist/vue-multiselect.css";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.wbk-projects-container {
    display: flex;
}
.wbk-projects-column {
    width: 50%;
}
</style>